import { FC } from "react";
import { GridProps } from "./Grid.interface";
import { StyledGrid } from "./Grid.styled";

const Grid: FC<GridProps> = ({ tag = 'div', ...rest }) => {
  return <StyledGrid as={tag} {...rest} />
}

export default Grid;